export default class Load {
  // load
  columnDeadLoad = 400 // kips
  columnLiveLoad = 270 // kips
  floorLoad = 100 // psf
  fillDepth = 6 // inches
  fillDensity = 120 // lb/ft^3
  floorSlabThickness = 6
  floorSlabDensity = 150
  
  deserialize(json) {
    Object.assign(this, json)
    this.dirty = false
  }

  serialize() {
    const d = {}
    Object.keys(this).forEach( (key) => d[key] = this[key] )
    return d
  }

  onUpdate(detail) {
    this.columnDeadLoad = detail.columnDeadLoad
    this.columnLiveLoad = detail.columnLiveLoad
    this.floorLoad = detail.floorLoad
    this.fillDepth = detail.fillDepth
    this.fillDensity = detail.fillDensity
    this.floorSlabThickness = detail.floorSlabThickness
    this.floorSlabDensity = detail.floorSlabDensity

    document.dispatchEvent(new CustomEvent('load-changed'))
  }
}